import { Environment } from './environment-definition';

export const environment: Environment = {
  dev: false,
  integrationTest: false,
  production: true
};
